import { FileUploaderEntity, FileUploaderRestEntity } from '@rp/shared/models';

const toRest = (fileUploaderEntity: FileUploaderEntity): FileUploaderRestEntity => ({
  fileName: fileUploaderEntity?.fileName,
  fileSize: fileUploaderEntity?.newFile?.size,
  fileExtension: fileUploaderEntity?.fileExtension,
});

const fromRest = (fileUploaderEntity: FileUploaderRestEntity): FileUploaderEntity => ({
  fileId: fileUploaderEntity?.fileId,
  fileName: fileUploaderEntity?.fileName,
  fileExtension: fileUploaderEntity?.fileExtension,
});

export const FileUploaderEntityAdapter = {
  toRest,
  fromRest,
};
